import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {getSchoolYear} from "../../../../utils/authority";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import Utils from "../../../../utils/utils";
import ModalDeleteClassCLB from "./modalDeleteStudentInCLB";
import CLBController from "../../../../services/system/clb/clb-controller";
import AutoSearchPeople from "../../../../components/auto-search-people";
import moment from "moment";
import CLBRegisterController from "../../../../services/system/clb-register/clb-register-controller";
registerLocale("vi", vi);


class RegisterCLBManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            teachId: -1,
            principalId: '',
            principalName: '',
            principalUsername: '',

            listData: [],
            countStates: [],

            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,

            listStyleStatus: [],
            listCLB: [],
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "clb",
                    name: "Tên CLB",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "teacher",
                    name: "Tên giáo viên",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "startDay",
                    name: "Ngày bắt đầu",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "endDay",
                    name: "Ngày kết thúc",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Học phí",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "phuphi",
                    name: "Phụ phí",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "number",
                    name: "Số buổi học",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "study",
                    name: "Buổi học",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Đã đăng ký",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListCLB()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListCLB();
            }
        );
    };
    onHandleRefresh() {
        this.setState({
            name: '',
            teachId: -1,
            principalId: '',
            principalName: '',
            principalUsername: '',

            listData: [],
            countStates: [],

            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,
        }, ()=>{
            this.getListCLB()
        });
    }

    renderStatus() {
        let listStatus = [
            {
                "id": "WAIT_PUBLISH",
                "name": "Chờ phát hành"
            },
            {
                "id": "PUBLISH",
                "name": "Đã phát hành"
            },
            {
                "id": "LOCKED",
                "name": "Đã khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getStatus(status){
        if(status == "WAIT_PUBLISH"){
            return <span className="badge badge-warning" style={{color: "white"}}>Chờ phát hành</span>
        }else if (status == "PUBLISH"){
            return <span className="badge badge-success" style={{color: "white"}}>Đã phát hành</span>
        }else
            return <span className="badge badge-success" style={{color: "white"}}>Khóa</span>
    }
    getListCLB() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: this.state.name,
            state: this.state.state,
            teachId: this.state.principalId != ""?parseInt(this.state.principalId): -1,
            pageNumber:0,
            pageSize: 10,
            sort: "created_at desc",
        };
        CLBRegisterController.listRegister(payload, res => {
            this.setState({
                listData: res.data.content,
            });
        })
    }
    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="register-clb" parentClass="clb-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                                <div className="content-loading col-12 ml-3 align-items-center"
                                     style={{display: 'block'}}>
                                    <div className="spinner-grow text-info"/>
                                </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý lớp CLB"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tên lớp CLB</label>
                                                <input
                                                    placeholder="Nhập tên lớp CLB"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.name}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.getListCLB()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({name: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Giáo viên dạy</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.principalId}
                                                    principalName={this.state.principalName}
                                                    principalUsername={this.state.principalUsername}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({principalId: principalId, principalName: principalName, principalUsername: principalUsername})}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        }, () =>{
                                                            this.getListCLB()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.getListCLB()}
                                                >
                                                    Tìm kiếm
                                                </button>

                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm ml-3"
                                                    onClick={() => this.onHandleRefresh()}
                                                >
                                                    Refresh
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <LinkPlus
                                                    style={{color: '#000'}}
                                                    to={{
                                                        pathname: "/ad-sas-school/them-hoc-sinh-vao-lop-clb",
                                                        state: {
                                                            fromDashboard: true,
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </LinkPlus>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "left"
                                                 }}>
                                                <label className="label-item col-12"><b>Lưu ý:</b> </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                        listData.length > 0 &&
                                                        listData?.map((row, index) => (
                                                            <tr style={{height: 50}}>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                    {" "}
                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                        index +
                                                                        1}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.name}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.headTeacherRes.fullName}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {moment(row.startDay).format("DD-MM-YYYY")}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {moment(row.endDay).format("DD-MM-YYYY")}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {Utils.formatMoney(parseFloat(row.price))} đ
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {Utils.formatMoney(parseFloat(row.surcharge))} đ
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {row.numberSessions}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {row.schoolDay}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {row.totalStudent}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {this.getStatus(row.state)}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    <LinkPlus
                                                                        style={{color: '#000'}}
                                                                        to={{
                                                                            pathname: "/ad-sas-school/them-hoc-sinh-vao-lop-clb",
                                                                            search: createSearchParams({
                                                                                id: `${row.id}`
                                                                            }).toString(),
                                                                            state: {
                                                                                fromDashboard: true,
                                                                                id: row.id
                                                                            }
                                                                        }}
                                                                    >
                                                                        <button className="btn btn-action p-2"
                                                                                title='Sửa'
                                                                                style={{cursor: 'pointer'}}
                                                                        >
                                                                            <i className="ti-pencil-alt"/>
                                                                        </button>
                                                                    </LinkPlus>
                                                                    <button className="btn btn-action p-2"
                                                                            title='Xóa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-trash"/>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteClassCLB
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListCLB()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default RegisterCLBManagement;
